import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'app-calculator',
    styleUrls: ['./calculator.component.scss'],
    templateUrl: './calculator.component.html',
    standalone: false
})
export class CalculatorComponent {


  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let el = document.getElementById("kt_explore");
    if (el?.classList.contains("drawer-on")) {
      if (event.key == "0" || event.key == "1" || event.key == "2" || event.key == "3" || event.key == "4" || event.key == "5" || event.key == "6" || event.key == "7" || event.key == "8" || event.key == "9" || event.key == ".")
        this.pressNum(event.key)

      if (event.key == "/" || event.key == "*" || event.key == "-" || event.key == "+")
        this.pressOperator(event.key)
    }


  }

  input: string = '';
  result: string = '';
  isAnswer: boolean = false;

  pressNum(num: string) {

    if (this.isAnswer)
      this.input = "";
    this.isAnswer = false;

    //Do Not Allow . more than once
    if (num == ".") {
      if (this.input != "") {

        const lastNum = this.getLastOperand()

        if (lastNum.lastIndexOf(".") >= 0) return;
      }
    }

    //Do Not Allow 0 at beginning.
    //Javascript will throw Octal literals are not allowed in strict mode.
    if (num == "0") {
      if (this.input == "") {
        return;
      }
      const PrevKey = this.input[this.input.length - 1];
      if (PrevKey === '/' || PrevKey === '*' || PrevKey === '-' || PrevKey === '+') {
        return;
      }
    }

    this.input = this.input + num;
    this.calcAnswer();
  }


  getLastOperand() {
    let pos: number;

    pos = this.input.toString().lastIndexOf("+");
    if (this.input.toString().lastIndexOf("-") > pos) pos = this.input.lastIndexOf("-")
    if (this.input.toString().lastIndexOf("*") > pos) pos = this.input.lastIndexOf("*")
    if (this.input.toString().lastIndexOf("/") > pos) pos = this.input.lastIndexOf("/")

    return this.input.substr(pos + 1)
  }


  pressOperator(op: string) {
    this.isAnswer = false;
    //Do not allow operators more than once
    const lastKey = this.input[this.input.length - 1];
    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+') {
      return;
    }

    this.input = this.input + op
    this.calcAnswer();
  }


  clear() {
    if (this.input != "" && !this.isAnswer) {
      this.input = this.input.substr(0, this.input.length - 1)
    }
  }

  allClear() {
    this.isAnswer = false;
    this.result = '';
    this.input = '';
  }

  calcAnswer() {

    let formula = this.input;

    let lastKey = formula[formula.length - 1];

    if (lastKey === '.') {
      formula = formula.substr(0, formula.length - 1);
    }

    lastKey = formula[formula.length - 1];

    if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+' || lastKey === '.') {
      formula = formula.substr(0, formula.length - 1);
    }

    this.result = eval(formula);
  }

  getAnswer() {
    this.calcAnswer();
    this.isAnswer = true;
    this.input = this.result;

    if (this.input == "0") this.input = "";
  }

}
